module.exports = __webpack_public_path__ + "assets/img/toc-pro-icon.153855d4.svg";